const gbFlat = [
    {
        label: 'GB Flat (turf & AW)',
        value: 'GB/flat',
    },
    {
        label: 'GB Flat turf',
        value: 'GB/flat/turf',
    },
    {
        label: 'GB AW',
        value: 'GB/flat/aw',
    },
];
const gbJumps = [
    {
        label: 'GB jumps',
        value: 'GB/jumps',
    },
];
const ireFlat = [
    {
        label: 'Irish Flat (turf & AW)',
        value: 'IRE/flat',
    },
    {
        label: 'Irish Flat turf',
        value: 'IRE/flat/turf',
    },
    {
        label: 'Irish AW',
        value: 'IRE/flat/aw',
    },
];
const ireJumps = [
    {
        label: 'Irish jumps',
        value: 'IRE/jumps',
    },
];

const human = [
    ...gbFlat,
    ...gbJumps,
    ...ireFlat,
    ...ireJumps,
];

const horse = {
    flat: [...gbFlat, ...ireFlat],
    jumps: [...gbJumps, ...ireJumps],
};

const course = {
    flat: {
        value: 'flat',
        label: 'Flat',
    },
    jumps: {
        value: 'jumps',
        label: 'Jumps',
    },
    flatTurf: {
        label: 'Flat turf',
        value: 'flat',
    },
    aw: {
        label: 'AW',
        value: 'flat',
    },
};

const getForCourse = (typeCode, seasonsAvailable, isStats = false) => {
    const shouldShowJumps =
        isStats && Object.prototype.hasOwnProperty.call(seasonsAvailable, 'JUMPS');
    const { flatTurf, aw, jumps } = course;
    switch (typeCode) {
        case 'J':
        case 'P': return [jumps];
        case 'F': return [flatTurf];
        case 'B': return [flatTurf, jumps];
        case 'X': return shouldShowJumps ? [aw, jumps] : [aw];
        default : return [];
    }
};

export default { human, horse, course, getForCourse };



// WEBPACK FOOTER //
// ./src/js/utils/filter/raceTypes.js